import { useState, useEffect } from 'react'

const useProductFruitsIsReady = () => {
  const [isReady, setIsReady] = useState(false)
  const productFruitsIsReady = window?.productFruitsIsReady ?? false

  useEffect(() => {
    setIsReady(productFruitsIsReady)
  }, [productFruitsIsReady])

  return isReady
}

export default useProductFruitsIsReady
